import { render, staticRenderFns } from "./ActiveSwitch.vue?vue&type=template&id=0850e509&scoped=true"
import script from "./ActiveSwitch.vue?vue&type=script&lang=js"
export * from "./ActiveSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0850e509",
  null
  
)

export default component.exports